// A character's score is normalized by the number of questions where they appear.
// This prevents characters offered more often from winning by construction.
export function quizWinner(answers, opportunities) {
  const votes = {};
  for (const key of answers) if (key) votes[key] = (votes[key] || 0) + 1;
  return Object.keys(votes).sort((a, b) =>
    (votes[b] / (opportunities[b] || 1)) - (votes[a] / (opportunities[a] || 1)) ||
    votes[b] - votes[a] || answers.lastIndexOf(b) - answers.lastIndexOf(a)
  )[0] || null;
}
function initQuiz(root) {
  if (root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const i18n = root.dataset;
  const dialog = root.querySelector('dialog');
  const steps = [...root.querySelectorAll('[data-step]')];
  const questions = steps.filter(s => s.dataset.step === 'question');
  const results = [...root.querySelectorAll('[data-result]')];
  const progress = root.querySelector('progress');
  const status = root.querySelector('[data-status]');
  const back = root.querySelector('[data-back]');
  const opportunities = {};
  questions.forEach(q => new Set([...q.querySelectorAll('[data-choice]')].map(b => b.dataset.choice))
    .forEach(key => { opportunities[key] = (opportunities[key] || 0) + 1; }));
  let answers = [], index = -1, opener, priorOverflow;
  function show(step) {
    steps.forEach(s => { s.hidden = s !== step; });
    back.hidden = index < 0 || index >= questions.length;
    status.textContent = index < 0 ? i18n.i18nQuizTitle : index >= questions.length ? i18n.i18nQuizResult : i18n.i18nQuestion + ' ' + (index + 1) + ' / ' + questions.length;
    progress.value = Math.min(answers.length, questions.length);
    dialog.querySelector('.ykt-qz-box').scrollTop = 0;
    const visibleContent = step.dataset.step === 'result' ? results.find(r => !r.hidden) : step;
    const focus = visibleContent?.querySelector('[data-focus]') || step.querySelector('button,a');
    focus?.focus({preventScroll:true});
  }
  function start() { answers = []; index = 0; show(questions[0]); }
  function open(event) {
    opener = event?.target?.closest('[data-ykt-quiz-open]') || document.activeElement;
    if (dialog.open) return;
    answers = []; index = -1;
    priorOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.showModal(); show(steps[0]);
  }
  function close() { dialog.close(); }
  dialog.addEventListener('close', () => { document.body.style.overflow = priorOverflow || ''; opener?.focus(); });
  dialog.addEventListener('click', e => {
    if (e.target === dialog || e.target.closest('[data-close]')) return close();
    if (e.target.closest('[data-start]')) return start();
    if (e.target.closest('[data-back]')) {
      index = Math.max(0,index-1); answers = answers.slice(0,index); show(questions[index]); return;
    }
    const choice = e.target.closest('[data-choice]');
    if (choice && index >= 0 && index < questions.length && questions[index].contains(choice)) {
      answers[index] = choice.dataset.choice; index++;
      if (index < questions.length) show(questions[index]);
      else {
        const winner = quizWinner(answers, opportunities);
        results.forEach(r => { r.hidden = r.dataset.result !== winner; });
        if (!results.some(r => !r.hidden) && results[0]) results[0].hidden = false;
        show(steps.find(s => s.dataset.step === 'result'));
      }
    }
    if (e.target.closest('[data-share]')) {
      const name = results.find(r => !r.hidden)?.dataset.name || '';
      const text = i18n.i18nShare.replace('__NAME__', name);
      const url = new URL(root.dataset.quizUrl, location.origin).href;
      if (navigator.share) navigator.share({title:i18n.i18nShareTitle,text,url}).catch(()=>{});
      else if (navigator.clipboard) navigator.clipboard.writeText(text + ' ' + url).then(()=>{
        root.querySelector('[data-share-status]').textContent = i18n.i18nCopied;
      }).catch(()=>{ root.querySelector('[data-share-status]').textContent = i18n.i18nShareFallback; });
    }
  });
  document.addEventListener('click', e => { if (root.isConnected && e.target.closest('[data-ykt-quiz-open]')) {e.preventDefault();open(e);} });
  // Native dialog handles Escape, focus containment and inert background.
}
if (typeof document !== 'undefined') {
  document.querySelectorAll('[data-ykt-quiz]').forEach(initQuiz);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-ykt-quiz]').forEach(initQuiz));
}
